import { useForm } from '@refinedev/antd';
import { Create } from '@refinedev/antd';
import { Form, Input, Checkbox, Card, Row, Col, Divider } from 'antd';
import { LabelWithHelp, SectionTitle } from '../../components/ui/HelpTooltip';

const permissionGroups = [
  {
    title: 'Foydalanuvchilar',
    key: 'users',
    permissions: ['read', 'update', 'block'],
    help: "Foydalanuvchilar ro'yxati va ularni boshqarish",
  },
  {
    title: 'Haydovchilar',
    key: 'drivers',
    permissions: ['read', 'update', 'verify', 'block'],
    help: "Haydovchilar ro'yxati, tasdiqlash va boshqarish",
  },
  {
    title: 'Hujjatlar',
    key: 'documents',
    permissions: ['read', 'review'],
    help: "Haydovchi hujjatlarini ko'rish va tasdiqlash",
  },
  {
    title: 'Sayohatlar',
    key: 'trips',
    permissions: ['read', 'update', 'cancel'],
    help: "Sayohatlarni ko'rish, tahrirlash va bekor qilish",
  },
  {
    title: "To'lovlar",
    key: 'payments',
    permissions: ['read'],
    help: "To'lovlar tarixini ko'rish",
  },
  {
    title: 'Murojatlar',
    key: 'support',
    permissions: ['read', 'reply', 'resolve'],
    help: "Foydalanuvchi murojatlarini ko'rish va javob berish",
  },
  {
    title: 'FAQ',
    key: 'faq',
    permissions: ['read', 'create', 'update', 'delete'],
    help: "Ko'p so'raladigan savollarni boshqarish",
  },
  {
    title: 'Promo kodlar',
    key: 'promo',
    permissions: ['read', 'create', 'update', 'delete'],
    help: "Chegirma kodlarini yaratish va boshqarish",
  },
  {
    title: 'Sozlamalar',
    key: 'settings',
    permissions: ['read', 'update'],
    help: "Tizim sozlamalarini o'zgartirish",
  },
  {
    title: 'Xodimlar',
    key: 'staff',
    permissions: ['read', 'create', 'update', 'delete'],
    help: "Admin xodimlarni yaratish va boshqarish",
  },
];

const permissionLabels: Record<string, string> = {
  read: "Ko'rish",
  create: 'Yaratish',
  update: 'Tahrirlash',
  delete: "O'chirish",
  block: 'Bloklash',
  verify: 'Tasdiqlash',
  review: "Ko'rib chiqish",
  reply: 'Javob berish',
  resolve: 'Hal qilish',
  cancel: 'Bekor qilish',
};

export const StaffCreate = () => {
  const { formProps, saveButtonProps } = useForm({
    resource: 'admin/staff',
    redirect: 'list',
  });

  return (
    <Create saveButtonProps={saveButtonProps} title="Yangi xodim">
      <Form {...formProps} layout="vertical">
        <Row gutter={24}>
          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Asosiy ma'lumotlar"
                  help="Xodimning kirish ma'lumotlari va shaxsiy ma'lumotlari"
                />
              }
            >
              <Form.Item
                label={
                  <LabelWithHelp
                    label="Login"
                    help="Xodim admin panelga kirish uchun foydalanadigan login. Kamida 3 ta belgi."
                  />
                }
                name="username"
                rules={[
                  { required: true, message: 'Loginni kiriting' },
                  { min: 3, message: "Kamida 3 ta belgi bo'lishi kerak" },
                ]}
              >
                <Input placeholder="admin" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Parol"
                    help="Xodim uchun parol. Kamida 6 ta belgi. Xavfsiz parol tanlang."
                  />
                }
                name="password"
                rules={[
                  { required: true, message: 'Parolni kiriting' },
                  { min: 6, message: "Kamida 6 ta belgi bo'lishi kerak" },
                ]}
              >
                <Input.Password placeholder="Kamida 6 ta belgi" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="To'liq ism"
                    help="Xodimning to'liq ismi va familiyasi"
                  />
                }
                name="fullName"
              >
                <Input placeholder="Abdullayev Abdulla" />
              </Form.Item>

              <Form.Item
                label={
                  <LabelWithHelp
                    label="Telefon"
                    help="Xodimning telefon raqami. Aloqa uchun ishlatiladi."
                  />
                }
                name="phone"
              >
                <Input placeholder="+998901234567" />
              </Form.Item>
            </Card>
          </Col>

          <Col xs={24} lg={12}>
            <Card
              title={
                <SectionTitle
                  title="Ruxsatlar"
                  help="Xodimga qaysi bo'limlarga kirish va qanday amallar bajarishga ruxsat beriladi"
                />
              }
            >
              {permissionGroups.map((group) => (
                <div key={group.key} style={{ marginBottom: 16 }}>
                  <div style={{ fontWeight: 500, marginBottom: 8, display: 'flex', alignItems: 'center', gap: 4 }}>
                    <LabelWithHelp label={group.title} help={group.help} />
                  </div>
                  <Form.Item name={['permissions', group.key]} noStyle>
                    <Checkbox.Group>
                      {group.permissions.map((perm) => (
                        <Checkbox key={perm} value={perm}>
                          {permissionLabels[perm] || perm}
                        </Checkbox>
                      ))}
                    </Checkbox.Group>
                  </Form.Item>
                  <Divider style={{ margin: '12px 0' }} />
                </div>
              ))}
            </Card>
          </Col>
        </Row>
      </Form>
    </Create>
  );
};
